import axios from 'axios'
import { notification } from './notification'

const getBookByIsbn = async isbn => {
  try {
    const { data } = await axios.get(
      `https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}`
    )
    const result = testReponse(data)
    return result
  } catch (e) {
    if (e.response) {
      if (e.response?.status === 404) {
        notification('Obra não encontrada!')
      }
    }
  }
}

const testReponse = resp => {
  if (resp.totalItems === 0) {
    notification('Obra não encontrada!', 'error')
    return null
  }
  return resp.items[0]
}

export default getBookByIsbn
